// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductPriceTableCell from "../Product/ProductPriceTableCell.res.js";

function CartProductUnitPriceTableCell(props) {
  let dispatch = props.onRequestDispatch;
  let __editable = props.editable;
  let product = props.product;
  let editable = __editable !== undefined ? __editable : false;
  let match;
  if (product.TAG === "Unit") {
    let match$1 = product._0;
    match = [
      match$1.id,
      match$1.unitPrice
    ];
  } else {
    let match$2 = product._0;
    match = [
      match$2.id,
      match$2.unitPrice
    ];
  }
  let unitPrice = match[1];
  let productId = match[0];
  let formattedUnitPrice = I18n.currencyFormat(undefined, "EUR", 3, 3, unitPrice);
  let formattedUnitPrice$1;
  if (product.TAG === "Unit") {
    formattedUnitPrice$1 = formattedUnitPrice;
  } else {
    let unit = product._0.capacityUnit;
    formattedUnitPrice$1 = unit !== undefined ? formattedUnitPrice + `/` + unit : formattedUnitPrice;
  }
  let inputAppender;
  if (product.TAG === "Unit") {
    inputAppender = {
      TAG: "Currency",
      _0: "EUR"
    };
  } else {
    let unit$1 = product._0.capacityUnit;
    inputAppender = unit$1 !== undefined ? ({
        TAG: "Custom",
        _0: I18n.toCurrencySymbol("EUR") + (`/` + unit$1)
      }) : ({
        TAG: "Currency",
        _0: "EUR"
      });
  }
  if (editable) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(InputNumberField.make, {
        value: unitPrice,
        minValue: 0,
        precision: 3,
        appender: inputAppender,
        shrinkInput: true,
        hideStepper: true,
        onChange: newPrice => dispatch({
          TAG: "ProductUnitPriceUpdated",
          _0: productId,
          _1: newPrice
        })
      })
    });
  } else {
    return JsxRuntime.jsx(ProductPriceTableCell.make, {
      value: formattedUnitPrice$1
    });
  }
}

let make = React.memo(CartProductUnitPriceTableCell, (oldProps, newProps) => {
  if (oldProps.product === newProps.product) {
    return oldProps.editable === newProps.editable;
  } else {
    return false;
  }
});

export {
  make,
}
/* make Not a pure module */
